import PropTypes from 'prop-types';

import StockAdjustmentCommandBar from './StockAdjustmentCommandBar';
import StockAdjustmentDetailSection from './StockAdjustmentDetailSection';
import StockAdjustmentMainInfoCard from './StockAdjustmentMainInfoCard';

const StockAdjustmentBlock = ({
  detail,
  defaultOpen = true,
  onRefetch,
  showActions = false,
}) => (
  <div className="receipt-card-elevate">
    <div className="receipt-card-surface">
      <StockAdjustmentMainInfoCard
        detail={detail}
        embedded
        actions={
          showActions ? (
            <StockAdjustmentCommandBar
              key={`${detail.id}-${detail.record?.updatedAt ?? ''}`}
              detail={detail}
              onRefetch={onRefetch}
            />
          ) : null
        }
      />
      <StockAdjustmentDetailSection detail={detail} embedded defaultOpen={defaultOpen} />
    </div>
  </div>
);

StockAdjustmentBlock.propTypes = {
  detail: PropTypes.shape({
    id: PropTypes.string,
    adjustmentNo: PropTypes.string,
    status: PropTypes.string,
    record: PropTypes.shape({
      updatedAt: PropTypes.string,
    }),
    lines: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  defaultOpen: PropTypes.bool,
  onRefetch: PropTypes.func,
  showActions: PropTypes.bool,
};

export default StockAdjustmentBlock;
